import React, { useRef, useState, useCallback, useEffect } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { AnchorLink } from 'gatsby-plugin-anchor-links';
import 'rc-slider/assets/index.css';

import useMediaQuery from '../hooks/useMediaQuery';

import Layout from '../components/layout';
import Seo from '../components/seo';

import Faq from '../components/Faq';
import Pricing from '../components/Pricing';
import Modal from '../components/Modal';

import scrollFactory from '../js/scroll';

const Index = () => {
  const isMobile = useMediaQuery('(max-width: 767px)');
  const heroContainer = useRef();
  const heroImage = useRef();

  const heroCardOne = useRef();
  const heroCardTwo = useRef();
  const heroCardThree = useRef();
  const centerHeroCard = useRef();
  const videoContainer = useRef();
  const introVideo = useRef();
  const videoCardOne = useRef();
  const videoCardTwo = useRef();
  const videoCardThree = useRef();
  const videoCardFour = useRef();
  const sliderContainerMain = useRef();
  const sliderContainerOne = useRef();
  const sliderContainerTwo = useRef();
  const featureContainer = useRef();
  const tiltedCard = useRef();

  const animatePath = useRef();
  const roundOne = useRef();
  const roundTwo = useRef();
  const roundThree = useRef();

  const homeFeatureOne = useRef();
  const homeFeatureTwo = useRef();
  const homeFeatureThree = useRef();
  const homeFeatureFour = useRef();
  const homeAsset1 = useRef();
  const homeAsset2 = useRef();
  const homeAsset3 = useRef();
  const homeAsset4 = useRef();

  const [step, setStep] = useState(0);

  const [openModal, setOpenModal] = useState(false);

  const openModalToggle = useCallback(() => {
    setOpenModal((state) => !state);
  }, []);

  const [formSubmitted, setFormSubmitted] = useState(false);

  // const [scrollUp, setScrollUp] = useState(true);

  useEffect(() => {
    const scrollConsole = scrollFactory({
      featureContainer,
      centerHeroCard,
      videoContainer,
      sliderContainerMain,
      heroCardOne,
      heroCardTwo,
      heroCardThree,
      videoCardOne,
      videoCardTwo,
      videoCardThree,
      videoCardFour,
      sliderContainerOne,
      sliderContainerTwo,
      tiltedCard,
      homeFeatureOne,
      homeFeatureTwo,
      homeFeatureThree,
      homeFeatureFour,
      homeAsset1,
      homeAsset2,
      homeAsset3,
      homeAsset4,
    });
    window.addEventListener('scroll', scrollConsole, true);

    return () => {
      window.removeEventListener('scroll', scrollConsole, true);
    };
  }, []);

  return (
    <Layout openModalToggle={openModalToggle} /* scrollUp={scrollUp} */>
      <Seo />

      <div>
        <section className="index-hero" ref={heroContainer}>
          <div className="rectangle">
            <span className="big-gradient-circle gradient-anim red-gradient" />
            <span className="big-gradient-circle gradient-anim delay-1 " />
            <span className="big-gradient-circle gradient-anim delay-2 green-gradient" />
          </div>
          <div className="container">
            <div className="hero-content">
              <h1>
                See your next hire through a{' '}
                <span className="stroke stroke-circle">new lens.</span>
              </h1>
              <p>
                Quickly create job listings using video to help attract quality
                candidates using ClipHire Recruit.
              </p>
              <AnchorLink
                to="/#pricing"
                title="Pricing"
                className="button button-green"
                onAnchorLinkClick="">
                Check Pricing
              </AnchorLink>
            </div>
            <div className="hero-image" ref={heroImage}>
              <StaticImage
                placeholder="blurred"
                src="../images/hero-main.png"
                alt=""
                width={380}
              />
              {/* <img className="hero-main" src="/img/hero-main.png" alt="" /> */}
              <div className="hero-card card-1" ref={heroCardOne}>
                <svg
                  className="hero-card-inner"
                  width="0"
                  height="0"
                  viewBox="0 0 204 113"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <rect
                    x=".327"
                    y=".656"
                    width="203"
                    height="112"
                    rx="8"
                    fill="#FB0"
                  />
                  <mask
                    id="a"
                    maskUnits="userSpaceOnUse"
                    x="0"
                    y="0"
                    width="204"
                    height="113">
                    <rect
                      x=".327"
                      y=".656"
                      width="203"
                      height="112"
                      rx="8"
                      fill="#FB0"
                    />
                  </mask>
                  <g mask="url(#a)">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M192.578 41.805a.68.68 0 00-.807-.523l-2.882.615-.615-2.882a.68.68 0 10-1.33.284l.615 2.882-2.882.615a.68.68 0 00.284 1.33l2.882-.615.615 2.882a.68.68 0 101.33-.284l-.615-2.882 2.882-.615a.68.68 0 00.523-.807z"
                      fill="#fff"
                    />
                    <path
                      d="M130.608 56.3a48.984 48.984 0 01-5.074-32.576s17.171 6.268 22.773 32.632l-17.699-.056z"
                      fill="#D07A00"
                    />
                    <path
                      d="M143.371 41.895s7.195-25.153 29.395-30.634c0 0 10.896 19.132-3.747 45.162l-20.661-.065s-3.02-10.956-4.987-14.463z"
                      fill="#FF9500"
                    />
                    <path
                      d="M139.917 56.756a.413.413 0 01-.382-.25l-12.596-28.582a.419.419 0 01-.007-.32.42.42 0 01.381-.269.419.419 0 01.394.25l12.595 28.582a.412.412 0 01-.182.541.417.417 0 01-.203.048z"
                      fill="#fff"
                    />
                    <path
                      d="M136.678 49.372h-.062a.418.418 0 01-.345-.314.41.41 0 01-.006-.164l1.058-6.904a.397.397 0 01.162-.28.406.406 0 01.315-.07.412.412 0 01.351.477l-1.057 6.904a.416.416 0 01-.416.35zM133.593 42.463a.427.427 0 01-.207-.052l-5.644-3.28a.418.418 0 11.417-.724l5.644 3.28a.413.413 0 01-.21.776zM154.312 56.8a.428.428 0 01-.156 0 .414.414 0 01-.226-.54l16.491-40.409a.421.421 0 01.545-.23.416.416 0 01.231.543l-16.491 40.41a.417.417 0 01-.394.227z"
                      fill="#fff"
                    />
                    <path
                      d="M159.229 44.748a.412.412 0 01-.413-.353l-2.601-15.781a.4.4 0 01.006-.162.41.41 0 01.337-.314.415.415 0 01.476.344l2.611 15.801a.4.4 0 01-.006.162.402.402 0 01-.186.258.408.408 0 01-.151.056l-.073-.01zM163.821 33.495a.414.414 0 01-.184-.787l8.88-4.498a.42.42 0 11.38.747l-8.879 4.498a.433.433 0 01-.197.04z"
                      fill="#fff"
                    />
                    <path
                      d="M150.184 100.855a22.13 22.13 0 01-22.057-20.182l-2.322-25.225 49.047.156-2.483 25.2a22.13 22.13 0 01-22.185 20.051zm-22.551-43.723l2.152 23.391a20.557 20.557 0 0040.917.13l2.301-23.377-45.37-.144z"
                      fill="#FF9500"
                    />
                    <path
                      d="M150.184 100.855a22.13 22.13 0 01-22.057-20.182l-2.322-25.225 49.047.156-2.483 25.2a22.13 22.13 0 01-22.185 20.051zm-22.551-43.723l2.152 23.391a20.557 20.557 0 0040.917.13l2.301-23.377-45.37-.144z"
                      fill="#FF9500"
                    />
                    <rect
                      x="13.327"
                      y="22.656"
                      width="73"
                      height="10"
                      rx="5"
                      fill="#FF9500"
                    />
                    <rect
                      x="13.327"
                      y="41.656"
                      width="45"
                      height="10"
                      rx="5"
                      fill="#FF9500"
                    />
                    <rect
                      x="13.385"
                      y="73.656"
                      width="82.616"
                      height="24.706"
                      rx="12.353"
                      fill="#FF9500"
                    />
                    <path
                      d="M35.069 89.453l.637-1.905h2.904l.64 1.905h1.494l-2.722-7.724h-1.728l-2.719 7.724h1.494zm1.014-3.029l1.045-3.11h.06l1.045 3.11h-2.15zm7.592 3.13c.995 0 1.444-.592 1.659-1.014h.083v.913h1.342v-7.724h-1.368v2.889h-.057c-.208-.419-.634-1.033-1.656-1.033-1.338 0-2.39 1.048-2.39 2.979 0 1.908 1.021 2.99 2.387 2.99zm.38-1.12c-.9 0-1.376-.792-1.376-1.878 0-1.078.468-1.851 1.376-1.851.88 0 1.362.728 1.362 1.851 0 1.124-.49 1.878-1.362 1.878zm6.309 1.12c.995 0 1.444-.592 1.66-1.014h.082v.913h1.343v-7.724h-1.37v2.889h-.056c-.207-.419-.633-1.033-1.655-1.033-1.34 0-2.391 1.048-2.391 2.979 0 1.908 1.022 2.99 2.387 2.99zm.38-1.12c-.9 0-1.376-.792-1.376-1.878 0-1.078.468-1.851 1.377-1.851.878 0 1.361.728 1.361 1.851 0 1.124-.49 1.878-1.361 1.878zm9.901-6.705v5.43c-.004.815-.38 1.249-1.052 1.249-.626 0-1.045-.38-1.056-1.007h-1.392c0 1.426 1.041 2.157 2.395 2.157 1.49 0 2.49-.905 2.493-2.398v-5.43h-1.388zm5.372 7.837c1.697 0 2.776-1.196 2.776-2.987 0-1.795-1.079-2.994-2.776-2.994-1.697 0-2.775 1.199-2.775 2.994 0 1.791 1.078 2.987 2.775 2.987zm.008-1.094c-.94 0-1.4-.837-1.4-1.897s.46-1.908 1.4-1.908c.924 0 1.384.849 1.384 1.908 0 1.06-.46 1.897-1.384 1.897zm3.987.98h1.343v-.912h.079c.215.422.663 1.014 1.66 1.014 1.364 0 2.386-1.082 2.386-2.99 0-1.931-1.052-2.98-2.39-2.98-1.023 0-1.449.615-1.656 1.034h-.057v-2.889h-1.365v7.724zm1.339-2.896c0-1.123.483-1.851 1.361-1.851.909 0 1.377.773 1.377 1.851 0 1.086-.475 1.878-1.377 1.878-.871 0-1.361-.754-1.361-1.878z"
                      fill="#fff"
                    />
                  </g>
                </svg>
              </div>
              <div className="hero-card card-2" ref={heroCardTwo}>
                <div className="hero-card-inner">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Layer_1"
                    x="0"
                    y="0"
                    version="1.1"
                    viewBox="0 0 35.8 40.8">
                    <path
                      fill="#68d3bc"
                      d="M22.6 39.6c8.6-3.3 12.9-12.9 9.6-21.5-3.3-8.6-12.9-12.9-21.5-9.6-8.6 3.3-12.9 13-9.6 21.6 3.3 8.6 13 12.8 21.5 9.5z"
                    />
                    <path d="M29.1 21.2V18.8c0-1.4-.6-2.8-1.6-3.8s-2.5-1.6-3.9-1.6h-9.1c-1.4 0-2.8.6-3.8 1.6s-1.6 2.5-1.6 3.9v2.2c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-2.2c0-.9.4-1.7 1-2.4.6-.6 1.4-.9 2.3-1h9c.9 0 1.7.4 2.4 1 .6.6 1 1.4 1 2.3V21.1c0 .6.5 1.1 1.1 1.1.5.1 1-.4 1-1zM24.7 5.4c-.1-3-2.5-5.4-5.6-5.4h-.2c-3 .1-5.4 2.5-5.4 5.6v.2c.1 3 2.5 5.4 5.6 5.4h.2c3-.1 5.4-2.5 5.4-5.6v-.2zm-5.5 3.5c-1.9 0-3.4-1.4-3.4-3.2v-.1c0-1.8 1.4-3.3 3.2-3.3h.1c1.8 0 3.3 1.4 3.3 3.2v.1c0 1.8-1.4 3.2-3.2 3.3zM35.8 21.1V18.8c0-1.2-.4-2.3-1.2-3.3-.8-1-1.8-1.7-3-2-.6-.2-1.2.2-1.4.8-.2.6.2 1.2.8 1.4.7.2 1.3.6 1.8 1.2.4.6.7 1.2.7 1.9V21.1c0 .6.5 1.1 1.1 1.1s1.2-.5 1.2-1.1zM26.6 2.3c.7.2 1.3.6 1.8 1.2.4.6.7 1.2.7 1.9v.1c0 .7-.2 1.5-.7 2-.5.6-1.1 1-1.8 1.2-.6.2-1 .8-.8 1.4.2.6.8 1 1.4.8 1.2-.3 2.3-1 3-2 .8-1 1.2-2.2 1.2-3.4v-.2c0-1.2-.4-2.3-1.2-3.3-.8-1-1.8-1.7-3-2-.7 0-1.3.4-1.4 1s.2 1.2.8 1.3z" />
                  </svg>
                  <h4>Post Job to get best candidates</h4>
                  <p>Start posting</p>
                </div>
              </div>
              <div className="hero-card card-3" ref={heroCardThree}>
                <div className="hero-card-inner">
                  <div className="flex-row no-margin">
                    <img src="/img/hero-card-thumb.png" alt="" />

                    <div>
                      <span className="line" />
                      <span className="line" />

                      <p>Add Video</p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="center-hero-card" ref={centerHeroCard}>
                <div className="flex-row no-margin nowrap">
                  <h3>Hire Best Talent out There :)</h3>
                  <svg
                    width="116"
                    height="141"
                    viewBox="0 0 116 141"
                    id="Layer_1"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M74.31 68.329H39.49l8.705 85.519h52.228l8.705-85.52H74.309zM105.704 56.65H42.915v8.64h62.789v-8.64z"
                      fill="#F2B08F"
                    />
                    <path
                      d="M115.316 65.29H33.295v3.04h82.021v-3.04zM42.138 94.337l3.384 33.25h57.574l3.384-33.25H42.138zM60.208 48H58v-1.617c.009-2.274.8-4.455 2.208-6.083 1.573-1.706 2.506-4.027 2.609-6.486 0-2.933-1.517-5.415-2.792-6.966C58.723 25.255 57.999 23.166 58 21h2.208c.007 1.537.527 3.015 1.459 4.137C63.208 27.017 65 30.053 65 33.794c-.1 3.102-1.255 6.04-3.225 8.207-1.01 1.167-1.581 2.73-1.592 4.362L60.208 48zM87.176 49H85v-1.797c.01-2.524.795-4.946 2.192-6.758 1.57-1.895 2.503-4.474 2.608-7.208 0-3.259-1.512-6.016-2.782-7.74C85.72 23.727 84.999 21.407 85 19h2.2c-.005 1.717.505 3.374 1.429 4.638C90.165 25.727 92 29.1 92 33.258c-.098 3.45-1.253 6.717-3.222 9.12-1 1.3-1.566 3.036-1.578 4.846L87.177 49z"
                      fill="#5A625D"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M18.667 43.36a.745.745 0 00-.913-.527l-3.12.836-.835-3.12a.745.745 0 10-1.44.386l.836 3.12-3.12.836a.745.745 0 10.386 1.44l3.12-.836.835 3.12a.746.746 0 001.44-.386l-.836-3.12 3.12-.836a.745.745 0 00.527-.913z"
                      fill="#FF9500"
                    />
                    <path
                      d="M38.386 12.464c.84-.596.487-1.917-.54-2.013l-5.11-.474a1.11 1.11 0 01-.804-.464l-2.966-4.189c-.596-.841-1.917-.487-2.012.54l-.475 5.11c-.03.323-.2.616-.464.804l-4.188 2.966c-.842.596-.488 1.917.539 2.012l5.11.475c.323.03.617.2.804.464l2.966 4.188c.596.842 1.917.488 2.012-.54l.475-5.11c.03-.322.2-.616.464-.803l4.188-2.966z"
                      fill="#FFDF00"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="hunt-jobs">
          <div className="small-container">
            <div className="intro-video-block" ref={videoContainer}>
              <video
                poster="/img/intro.jpg"
                type="video/mp4"
                className="intro-video"
                ref={introVideo}
                src="/video/intro.mp4"
                loop
                muted
                autoPlay
                playsInline
              />
              <div className="video-card video-card-1" ref={videoCardOne}>
                <img src="/img/intro-image-1.jpg" alt="" />
              </div>
              <div className="video-card video-card-2" ref={videoCardTwo}>
                <img src="/img/intro-image-2.jpg" alt="" />
              </div>
              <div className="video-card video-card-3" ref={videoCardThree}>
                <img src="/img/intro-image-3.jpg" alt="" />
              </div>
              <div className="video-card video-card-4" ref={videoCardFour}>
                <img src="/img/intro-image-4.jpg" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section className="index-how" id="how-it-works">
          <div className="container">
            <div className="how-tabs flex-row no-margin">
              <div className="tab-1 ">
                <div className="tab-image-wrapper">
                  <img src="/img/get-hired.svg" alt="" />
                </div>
                <div className="tab-content">
                  <h5>Access Top Talent For Your Company</h5>
                  <p>
                    Find the right candidate that understands your culture,
                    select from our vast community of job seekers. Interact with
                    people who are willing to go above and beyond for their next
                    role.
                  </p>
                </div>
              </div>
              <div className="tab-1 ">
                <div className="tab-image-wrapper">
                  <img src="/img/create-video.svg" alt="" />
                </div>
                <div className="tab-content">
                  <h5>Share Your Vision And Mission Using Videos</h5>
                  <p>
                    Communicate your core cultural principles, job requirements
                    and share all the details about the potential role with
                    candidates using interesting videos. Make hiring more human,
                    impactful and empathetic.
                  </p>
                </div>
              </div>
              <div className="tab-1 ">
                <div className="tab-image-wrapper">
                  <img src="/img/share-link.svg" alt="" />
                </div>
                <div className="tab-content">
                  <h5>Hire With Ease And Clarity</h5>
                  <p>
                    Save time, resources and energy while hiring. Simplify it by
                    screening candidates with the help of video resumes, know
                    who you would be bringing on board by seeing them face to
                    face!
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="tilted-cards">
          <div className="slider-container" ref={sliderContainerMain}>
            <div
              className="flex-row nowrap justify-flex-end slider-container-1"
              ref={sliderContainerOne}>
              <div>
                <img src="/img/slider-image-1.jpg" alt="" />
              </div>
              <div className="violet-bg">
                <div className="slider-card ">
                  <h4 className="text-center">Screen the Best Talent</h4>
                  <p className="text-center">
                    Get access to quality candidates and choose the best.
                  </p>
                </div>
              </div>
              <div className="slider-video">
                <video
                  poster="/img/video-1.jpg"
                  type="video/mp4"
                  src="/video/video-1.mp4"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>
              <div>
                <img src="/img/slider-image-2.jpg" alt="" />
              </div>
              <div className="yellow-bg">
                <div className="slider-card ">
                  <h4 className="text-center color-black">
                    Make Informed Decisions
                  </h4>
                  <p className="text-center color-black">
                    Simplify hiring by setting up your pre-requisites and
                    recruit right.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="flex-row nowrap slider-container-2"
              ref={sliderContainerTwo}>
              <div>
                <img src="/img/slider-image-3.jpg" alt="" />
              </div>
              <div className="slider-video">
                <video
                  poster="/img/video-3.jpg"
                  type="video/mp4"
                  src="/video/video-3.mp4"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>
              <div className="green-bg">
                <div className="slider-card ">
                  <h4 className="text-center">Communicate with Videos</h4>
                  <p className="text-center">
                    Strike an empathetic rapport with candidates and de-stress
                    them.
                  </p>
                </div>
              </div>
              <div className="slider-video">
                <video
                  poster="/img/video-5.jpg"
                  type="video/mp4"
                  src="/video/video-5.mp4"
                  autoPlay
                  muted
                  loop
                  playsInline
                />
              </div>
              <div>
                <img src="/img/slider-image-4.jpg" alt="" />
              </div>
            </div>
          </div>
        </section>

        <section className="feature" id="feature">
          <div className="small-container">
            <div className="feature-head">
              <h5 className="yellow-heading">Features</h5>
              <h3>We Put The "Human" Back In Human Resources.</h3>
            </div>
            <div className="flex-row col justify-content-between">
              <div className="feature-image-wrapper position-relative hidden-mobile">
                <div className="position-absolute">
                  <span className="big-gradient-circle gradient-anim red-gradient" />
                  <span className="big-gradient-circle gradient-anim delay-1 " />
                  <span className="big-gradient-circle gradient-anim delay-2 green-gradient" />
                </div>
                <div className="feature-image">
                  <img src="/img/feature-intro.png" alt="" />
                  <div className="asset" ref={homeAsset1}>
                    <div className="asset-inner asset-1">
                      <div className="flex-row no-margin">
                        <img src="/img/feature-small-1.png" alt="" />
                        <div>
                          <span className="line" />
                          <span className="line" />
                          <p>Share</p>
                        </div>
                      </div>
                    </div>
                    <img
                      className="asset-inner asset-2"
                      src="/img/feature-card-1-2.svg"
                      alt=""
                    />
                  </div>
                  <div className="asset" ref={homeAsset2}>
                    <img
                      className="asset-inner asset-3"
                      src="/img/feature-card-2-1.svg"
                      alt=""
                    />
                    <img
                      className="asset-inner asset-4"
                      src="/img/feature-card-2-2.svg"
                      alt=""
                    />
                  </div>
                  <div className="asset" ref={homeAsset3}>
                    <img
                      className="asset-inner asset-5"
                      src="/img/feature-card-3-1.svg"
                      alt=""
                    />
                    <img
                      className="asset-inner asset-6"
                      src="/img/feature-card-3-2.svg"
                      alt=""
                    />
                  </div>
                  <div className="asset" ref={homeAsset4}>
                    <div className="asset-inner asset-7">
                      <div className="violet-bg stars">
                        <img src="/img/feature-small-2.png" alt="" />
                      </div>
                      <img
                        className="lines-faded"
                        src="/img/lines-faded.svg"
                        alt=""
                      />
                    </div>
                    <img
                      className="asset-inner asset-8"
                      src="/img/feature-card-4-2.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div className="feature-content">
                <div className="feature-single" ref={homeFeatureOne}>
                  <div className="flex-row no-margin align-items-center">
                    <img src="/img/video-icon.svg" alt="" />
                    <h4>Video Description</h4>
                  </div>
                  <p>
                    Show candidates the benefits of your company and role with a
                    personalized 30-second video - share your mission, vision,
                    job details. Use videos to strike a warm, impactful first
                    impression as an employer and ease your potential recruits.
                  </p>
                  <img
                    className="visible-mobile"
                    src="/img/feature-mob-video.jpg"
                    alt=""
                  />
                </div>
                <div className="feature-single" ref={homeFeatureTwo}>
                  <div className="flex-row no-margin align-items-center">
                    <img src="/img/job-icon.svg" alt="" />
                    <h4>Job Postings</h4>
                  </div>
                  <p>
                    Share all the details, requirements, job roles and specifics
                    early on and allow candidates to know what they are signing
                    up for. Bridge the gap beforehand by communicating
                    everything about a potential job at your company.
                  </p>
                  <img
                    className="visible-mobile"
                    src="/img/feature-mob-job.jpg"
                    alt=""
                  />
                </div>
                <div className="feature-single" ref={homeFeatureThree}>
                  <div className="flex-row no-margin align-items-center">
                    <img src="/img/search-icon.svg" alt="" />
                    <h4>Candidate Search</h4>
                  </div>
                  <p>
                    Get access to the best talent by screening them as per your
                    pre-requisites and expectations. Search across job
                    functions, experience to select the right candidates that
                    fit your job profiles and initiate conversations.
                  </p>
                  <img
                    className="visible-mobile"
                    src="/img/feature-mob-search.jpg"
                    alt=""
                  />
                </div>
                <div className="feature-single" ref={homeFeatureFour}>
                  <div className="flex-row no-margin align-items-center">
                    <img src="/img/personalized-icon.svg" alt="" />
                    <h4>Personalized Branding Page</h4>
                  </div>
                  <p>
                    Go beyond your conventional website and LinkedIn, use
                    Cliphire Recruit to personalize your brand and showcase
                    yourself well as an employer - customize using logo, brand
                    colours and more. Communicate everything related to your
                    mission, vision, job openings and more through your
                    exclusive branding page.
                  </p>
                  <img
                    className="visible-mobile"
                    src="/img/feature-mob-personalized.jpg"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <Pricing
          setStep={setStep}
          step={step}
          openModalToggle={openModalToggle}
        />

        <section className="feature-cards-main">
          <div className="feature-card-group" ref={featureContainer}>
            <div className="flex-row nowrap no-margin">
              <div className="single-feature-card">
                <div className="inner-card yellow-bg">
                  <div className="center">
                    <div className="inner-card-image">
                      <img
                        className="yellow-asset-1"
                        src="/img/card-1.png"
                        alt=""
                      />
                      <img
                        className="yellow-asset-2"
                        src="/img/cursor-feature.svg"
                        alt=""
                      />
                      <div className="yellow-asset-3">
                        <p>
                          <span className="circle green" />
                          Recruiter
                        </p>
                        <p>
                          <span className="circle gray" />
                          Viewer
                        </p>
                      </div>
                    </div>
                  </div>
                  <div>
                    <h4>Assign Roles &#38; Permissions</h4>
                    <p>
                      Save your time, resources &#38; energy while hiring.
                      Collaborate with your team &#38; hire efficiently.
                    </p>
                  </div>
                </div>
              </div>
              <div className="single-feature-card">
                <div className="inner-card green-bg">
                  <div className="inner-card-image">
                    <div className="center">
                      <img
                        className="green-asset-1"
                        src="/img/card-2.png"
                        alt=""
                      />
                    </div>
                    <img
                      className="green-asset-2"
                      src="/img/card-2-blur.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <h4>Amplify your brand</h4>
                    <p>
                      Stand out with your branded site-including your company’s
                      own custom colors and much more...
                    </p>
                  </div>
                </div>
              </div>
              <div className="single-feature-card" ref={tiltedCard}>
                <div className="inner-card violet-bg">
                  <div className="inner-card-image">
                    <img
                      className="violet-asset-1"
                      src="/img/thumb-down.svg"
                      alt=""
                    />
                    <img
                      className="violet-asset-2"
                      src="/img/thumb-up.svg"
                      alt=""
                    />
                  </div>
                  <div>
                    <h4>Accept &#38; Reject Applicants</h4>
                    <p>
                      Take faster decisions with no efforts &#38; choose the
                      best talent fit for your organization
                    </p>
                  </div>
                </div>
              </div>
              <div className="single-feature-card">
                <div className="inner-card white-bg">
                  <div className="inner-card-image">
                    <img
                      className="white-asset-1"
                      src="/img/card-4.png"
                      alt=""
                    />
                  </div>
                  <div>
                    <h4>Share Profile</h4>
                    <p>
                      Quickly share candidate‘s profile of your choice on or off
                      the platform with a unique link...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Faq />

        <section
          className="margin-bottom-negative"
          style={{ overflow: 'hidden' }}>
          <div className="container">
            <div className="circular-video-section">
              <img src="/img/circular-image.png" alt="" />
              <div className="round-thumb-block">
                <div className="rotate linear infinite">
                  <div className="counter one">
                    <div className="inner">
                      <div ref={roundOne} className="round-img-thumb">
                        <video
                          poster="/img/video-2.jpg"
                          type="video/mp4"
                          src="/video/video-2.mp4"
                          alt=""
                          autoPlay
                          loop
                          muted
                          playsInline
                        />
                      </div>
                    </div>
                  </div>
                  <div className="counter two">
                    <div className="inner ">
                      <div ref={roundTwo} className="round-img-thumb">
                        <video
                          poster="/img/video-2.jpg"
                          type="video/mp4"
                          src="/video/video-4.mp4"
                          alt=""
                          autoPlay
                          loop
                          muted
                          playsInline
                        />
                      </div>
                    </div>
                  </div>
                  <div className="counter three">
                    <div className="inner ">
                      <div ref={roundThree} className="round-img-thumb">
                        <video
                          poster="/img/video-6.jpg"
                          type="video/mp4"
                          src="/video/video-6.mp4"
                          alt=""
                          autoPlay
                          loop
                          muted
                          playsInline
                        />
                      </div>
                    </div>
                  </div>
                  <div className="counter four">
                    <div className="inner ">
                      <div ref={roundTwo} className="round-img-thumb">
                        <video
                          poster="/img/video-4.jpg"
                          type="video/mp4"
                          src="/video/video-4.mp4"
                          alt=""
                          autoPlay
                          loop
                          muted
                          playsInline
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                id="Layer_1"
                x="0"
                y="0"
                version="1.1"
                viewBox="0 0 962 962">
                <path
                  ref={animatePath}
                  id="path"
                  fill="none"
                  stroke="#06cb87"
                  strokeWidth=".932"
                  d="M480.9.8h0C746.1.8 961.2 215.7 961.2 481h0c0 265.2-215.1 480.3-480.3 480.3h0C215.7 961.2.8 746.2.8 480.9h0C.8 215.7 215.7.8 480.9.8z"
                  opacity=".2"
                />
              </svg>
            </div>
          </div>
        </section>
      </div>
      <Modal
        openModal={openModal}
        openModalToggle={openModalToggle}
        setFormSubmitted={setFormSubmitted}
        step={step}
        formSubmitted={formSubmitted}
        isMobile={isMobile}
      />
    </Layout>
  );
};
export default Index;
